import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import "react-phone-input-2/lib/bootstrap.css";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import PhoneInput from "react-phone-input-2";

const EditUser = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const [Status, setStatus] = React.useState("default");
  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };
  const isAddUser = location.pathname === "/manage-users/add";

  return (
    <>
      <div className="main_title">
        <h1>{isAddUser ? "Add " : "Edit "} User</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-users")}>Manage Users</button>{" "}
          - {isAddUser ? "Add " : "Edit "} User
        </p>
      </div>

      <div className="cards">
        <div className="form">
          <div className="gap_p">
            <div className="control_group w_33">
              <label htmlFor="full-name">Full Name</label>
              <TextField id="full-name" placeholder="Name" hiddenLabel fullWidth />
            </div>

            <div className="control_group w_33">
              <label htmlFor="email">Email</label>
              <TextField id="email" type="email" placeholder="Email" hiddenLabel fullWidth />
            </div>
            <div className="control_group w_33">
              <label htmlFor="phone">Phone Number</label>
              <PhoneInput
                country={"in"}
                placeholder="Enter Phone Number"
                enableSearch={false}
                autoFormat={false}
                inputStyle={{ width: "100%" }}
              />
            </div>

           
            <div className="control_group w_33">
              <label htmlFor="member">Address</label>
              <TextField id="member" type="text" placeholder="Address" hiddenLabel fullWidth />
            </div>
          </div>

          <div className="form_btn">
            <Button className="btn btn_primary">Save</Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditUser;
